import { Injectable, Injector } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { IBaseResponse } from '@carm/_utils/models';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class CraService extends BaseApiService {
  constructor(protected injector: Injector) {
    super(injector);
  }

  public isCraDowntime(): Observable<boolean> {
    const endPoint = `${environment.business.cra.baseUrl}/downtime`;
    return this.httpAuthGet<IBaseResponse>(endPoint).pipe(
      map(response => response.responseStatus !== 'true')
    );
  }

  public isBusinessBlocked(businessId: string): Observable<boolean> {
    const endPoint = `${environment.business.cra.baseUrl}/blocked-bn-status`;
    const params = new HttpParams().set('businessId', businessId);
    return this.httpAuthGet<IBaseResponse>(endPoint, params).pipe(
      map(response => response.responseStatus !== 'true')
    );
  }
}
